/**
 * Calculate binomial coefficient (n choose k)
 */
export function choose(n: number, k: number): number {
  if (k < 0 || k > n) return 0;
  if (k === 0 || k === n) return 1;
  if (k > n / 2) k = n - k;

  let res = 1;
  for (let i = 1; i <= k; i++) {
    res = (res * (n - k + i)) / i;
  }
  return Math.round(res);
}

/**
 * Generate all combinations of size k from an array
 */
export function getCombinations<T>(arr: T[], k: number): T[][] {
  const result: T[][] = [];

  function backtrack(start: number, currentCombo: T[]) {
    if (currentCombo.length === k) {
      result.push([...currentCombo]);
      return;
    }

    for (let i = start; i < arr.length; i++) {
      currentCombo.push(arr[i]);
      backtrack(i + 1, currentCombo);
      currentCombo.pop();
    }
  }

  backtrack(0, []);
  return result;
}

/**
 * Calculate the maximum potential win for a system bet
 * Sum of (odds of combination * stake) for all combinations of size k
 */
export function calculateSystemPossibleWin(
  bets: { odds: string }[],
  k: number,
  stakePerCombination: number
): number {
  if (bets.length < k || k <= 0) return 0;

  const combinations = getCombinations(bets, k);
  let totalWin = 0;

  for (const combo of combinations) {
    const comboOdds = combo.reduce((acc, bet) => {
      const oddVal = parseFloat(bet.odds.replace(',', '.'));
      return acc * (isNaN(oddVal) ? 1 : oddVal);
    }, 1);
    totalWin += comboOdds * stakePerCombination;
  }

  return totalWin;
}
